import React from 'react';
import PropTypes from 'prop-types';
import BatchListItem from '../../../components/batches/batch-list-item';
import { BatchSinglePropType } from '../../../prop-types/batch-single';
import style from './move-to-batch-modal.module.less';

export const MoveToBatchModalBatchRow = ({ batch, setSelectedBatchId, selected = false }) => {
  const onRowClick = () => {
    const { fulfillmentPlanSetId } = batch;
    setSelectedBatchId(fulfillmentPlanSetId);
  };

  return (
    <div className={style['batch-list-item-wrapper']}>
      <BatchListItem batch={batch} className={style['batch-list-item-button']} onClick={onRowClick} selected={selected} />
    </div>
  );
};

MoveToBatchModalBatchRow.propTypes = {
  selected: PropTypes.bool,
  setSelectedBatchId: PropTypes.func.isRequired,
  batch: BatchSinglePropType.isRequired,
};
